/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';
import { isNullish } from '@/wpt-lib/utils/isNullish';

const Publications = ({
    publicationType,
    publications = [],
    targetNumberOfPublication,
    publicationBookStatus,
    conferenceLevel,
    conferenceParticipants,
}: Partial<{
    publicationType: string;
    publications: { name: string }[];
    targetNumberOfPublication: number;
    publicationBookStatus: string;
    conferenceLevel: string;
    conferenceParticipants: number;
}>) => {
    const label = useLabel('publicationType', publicationType ?? '');

    let short = label;
    if (label.includes('Book')) short = 'Book';
    else if (label.includes('Conference')) short = 'Conference';
    else if (label.includes('Journal')) short = 'Journal';

    return (
        <>
            <Row>
                <ValueCell single label={`${short} Type`} value={useLabel('publicationType', publicationType ?? '')} />
            </Row>
            <Row widths={[70, 30]}>
                <ListCell label={`${short} Titles`} values={publications.map((o) => o.name)} />
                <ValueCell label={`Targeted number of ${short}s`} value={targetNumberOfPublication} />
            </Row>
            {publicationBookStatus && (
                <Row>
                    <ValueCell
                        single
                        label="Book Status"
                        value={useLabel('publicationBookStatus', publicationBookStatus ?? '')}
                    />
                </Row>
            )}
            {!isNullish(conferenceParticipants) && (
                <Row>
                    <ValueCell single label="Conference Participants" value={conferenceParticipants} />
                </Row>
            )}
            {conferenceLevel && (
                <Row>
                    <ValueCell
                        single
                        label="Conference Level"
                        value={useLabel('conferenceLevel', conferenceLevel ?? '')}
                    />
                </Row>
            )}
        </>
    );
};

export default Publications;
